export interface PolicyInformation {
  insuranceChoice: string;
  insuranceName: string;
  insuranceCode: string;
  policyNumber: string;
  vatNumber?: string;
  insuredFirstname?: string;
  insuredLastname?: string;
  insuredEmail?: string;
  insuredPhoneNumber?: string;
  insuranceStartDate?: Date;
  insuranceEndDate?: Date;
  isGuaranteeConditionRetrieveWithSuccess?: boolean;
  isCancelled?: boolean;
  isCancelledWithoutPayment?: boolean;
  isSuspended?: boolean;
  isCovered?: boolean;
  coverBDG?: string;
  excessTakeover?: string;
  replacementDeductible?: number;
  repairDeductible?: number;
  replacementRateDeductible?: number;
  repairRateDeductible?: number;
  minReplacementDeductible?: number;
  maxReplacementDeductible?: number;
  minRepairDeductible?: number;
  maxRepairDeductible?: number;
  replacementGuaranteeCeiling?: number;
  repairGuaranteeCeiling?: number;
  sinisterNumber?: string;
}
